{
	"showButtonTitle": "Visa",
	"hideButtonTitle": "Dölj"
}
